import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";

export class CountriesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/countries`;
    const data = await super.getRequest<Model[]>(url, opts);

    data.sort((a, b) => (a.sortOrder - b.sortOrder) === 0 ? a.description.localeCompare(b.description, 'en') : a.sortOrder - b.sortOrder)
    
    return data.map( a => ({'id': a.id, 'label': a.description}))
  }
}